import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseDataService } from 'src/app/services/data/base-data.service';
import { TrackingRegistryView } from './list-individual.facade';
import { ListFilters } from './list-filter.service';

export interface ListIndividualState {
  items: TrackingRegistryView[];
  total: number;
  isLoading: boolean;
  page: number;
  pageSize: number;
  selectedWalletId: string | undefined;
  filters: ListFilters;
  sortColumn: string | null;
  sortDirection: 'asc' | 'desc';
  documentInput: string;
  canDownloadReport: boolean;
  isAlert30DaysWallet: boolean;
}

@Injectable()
export class ListIndividualStore extends BaseDataService<ListIndividualState> {
  constructor() {
    super(getInitialState());
  }

  setLoading(isLoading: boolean): void {
    this.updateState({ isLoading });
  }

  setItems(items: TrackingRegistryView[], total: number): void {
    this.updateState({
      items,
      total,
      isLoading: false,
    });
  }

  setPage(page: number): void {
    this.updateState({ page });
  }

  setPageSize(pageSize: number): void {
    this.updateState({
      pageSize,
      page: 0,
    });
  }

  setSelectedWallet(walletId: string): void {
    this.updateState({
      selectedWalletId: walletId,
      page: 0,
    });
  }

  setFilters(filters: ListFilters): void {
    this.updateState({
      filters,
      page: 0,
    });
  }

  setSort(column: string | null, direction: 'asc' | 'desc'): void {
    this.updateState({
      sortColumn: column,
      sortDirection: direction,
      page: 0,
    });
  }

  setDocumentInput(documentInput: string): void {
    this.updateState({ documentInput });
  }

  setCanDownloadReport(canDownload: boolean): void {
    this.updateState({ canDownloadReport: canDownload });
  }

  setAlert30DaysWallet(value: boolean): void {
    this.updateState({ isAlert30DaysWallet: value });
  }

  selectIsAlert30DaysWallet$(): Observable<boolean> {
    return this.select$('isAlert30DaysWallet');
  }

  override clearState(): void {
    super.clearState();
  }

  removeItem(itemId: string): void {
    const currentState = this.getStateValue();
    const updatedItems = currentState.items.filter((item) => item.id !== itemId);

    const itemWasRemoved = updatedItems.length !== currentState.items.length;
    const updatedTotal = itemWasRemoved ? Math.max(0, currentState.total - 1) : currentState.total;

    this.updateState({
      items: updatedItems,
      total: updatedTotal,
    });
  }

  updateItem(itemId: string, updates: Partial<TrackingRegistryView>): void {
    const currentState = this.getStateValue();
    const updatedItems = currentState.items.map((item) =>
      item.id === itemId ? { ...item, ...updates } : item,
    );

    this.updateState({ items: updatedItems });
  }
}

function getInitialState(): ListIndividualState {
  return {
    items: [],
    total: 0,
    isLoading: false,
    page: 0,
    pageSize: 10,
    selectedWalletId: undefined,
    filters: {},
    sortColumn: null,
    sortDirection: 'asc',
    documentInput: '',
    canDownloadReport: false,
    isAlert30DaysWallet: false,
  };
}
